export const PAYMENT_MODE = {
  CASH: 'CASH',
  MILES: 'MILES',
};

export const SPM_STATE = {
  SPM_INITIATE: 'SPM_INITIATE',
  SPM_CONFIRM: 'SPM_CONFIRM',
};

export const SPM_ERROR_STATUS = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  LOGIN_REQUIRED: 'LOGIN_REQUIRED',
  INSUFFICENT_MILES: 'INSUFFICENT_MILES',
  NOT_VALID_OBJECT: 'NOT_VALID_OBJECT',
  TRANSACTION_CANCELLED: 'TRANSACTION_CANCELLED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
};

export const API_ERROR_CODES = {
  LOGIN_REQUIRED: 'IM_40101',
  MILES_VALIDATION_ERROR: 90441027,
};

export const RESEND_OTP_TIMER = 60;

export const ENTER_OTP = 'Please enter the OTP.';
export const INVALID_OTP = 'Invalid OTP Number.';
export const OTP_LENGTH = 'Please enter 6 digit OTP';

export const EMAIL_OTP_SENT = 'An OTP has been sent to your registered Email ID';
export const MOBILE_OTP_SENT = 'An OTP has been sent to your registered phone number';
export const BOTH_CHANNEL_OTP_SENT = 'An OTP has been sent to your registered Email ID and phone number';

export const OTP_CHANNEL = {
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',
  EMAIL_MOBILE: 'EMAIL_MOBILE',
};

export const INSUFFICENT_MILES_CTA_EVENT = {
  CLOSE: 'CLOSE',
  CANCEL: 'CANCEL',
  PAY_VIA_INR: 'PAY_VIA_INR',
};

export const INSUFFICENT_MILES_MSG =
  'You do not have sufficient InterMiles to proceed with the transaction. You can pay via INR and Earn Miles';
